import * as React from "react";
import * as SwitchPrimitive from "@radix-ui/react-switch";
import { cn } from "@/lib/utils";

interface SwitchProps extends React.ComponentPropsWithoutRef<typeof SwitchPrimitive.Root> {
  label?: string;
}

const Switch = React.forwardRef<React.ElementRef<typeof SwitchPrimitive.Root>, SwitchProps>(
  ({ className, label, id, ...props }, ref) => (
    <div className="flex items-center gap-3">
      <SwitchPrimitive.Root
        className={cn(
          "relative h-[20px] w-[42px] cursor-pointer rounded-full bg-system-graphite outline-none",
          "data-[state=checked]:bg-system-primary",
          className
        )}
        id={id}
        ref={ref}
        {...props}
      >
        <SwitchPrimitive.Thumb
          className={cn(
            "block h-5 w-5 translate-x-0.5 rounded-full bg-system-disabled transition-transform duration-100",
            "data-[state=checked]:translate-x-[20px] data-[state=checked]:bg-white"
          )}
        />
      </SwitchPrimitive.Root>
      {label && (
        <label className="text- cursor-pointer text-system-disabled" htmlFor={id}>
          {label}
        </label>
      )}
    </div>
  )
);

Switch.displayName = SwitchPrimitive.Root.displayName;

export default Switch;
